/* istanbul ignore file */
/**
 * The default max results when fetching all metadata.
 */
export const FETCH_ALL_METADATA_MAX_RESULTS = 500;
